import { render, staticRenderFns } from "./SaitenBox.vue?vue&type=template&id=c3706bde&scoped=true&"
import script from "./SaitenBox.vue?vue&type=script&lang=ts&"
export * from "./SaitenBox.vue?vue&type=script&lang=ts&"
import style0 from "./SaitenBox.vue?vue&type=style&index=0&id=c3706bde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3706bde",
  null
  
)

export default component.exports